import { NotificationPreferences } from '@/components/NotificationPreferences';

export default function NotificationSettings() {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-neutral-900">Settings</h1>
        <p className="mt-2 text-neutral-600">
          Manage your notification preferences and account settings
        </p>
      </div>

      <NotificationPreferences />
    </div>
  );
}
